/**
 * Кто оператор и кому уходят данные — общее для всех трёх документов.
 *
 * Оператор — самозанятый (НПД, 422-ФЗ): ОГРНИП нет, домашний адрес не
 * публикуем — запросы по ПДн, претензии и отказ от подписки принимаются в
 * Telegram. Тексты — черновик по требованиям 152-ФЗ, ГК РФ, ЗоЗПП и 376-ФЗ;
 * перед запуском их должен вычитать юрист (DEPLOY.md, «Юридическое»).
 */
export const OPERATOR = {
  name: 'Кондратьев Дмитрий Александрович',
  status: 'плательщик налога на профессиональный доход',
  inn: '532114953282',
  /** Куда писать: запросы по ПДн, претензии, отказ от подписки. */
  contact: { href: 'https://t.me/boltaem_app?direct', label: '@boltaem_app в Telegram' },
} as const;

/** «Кондратьев Д. А. (плательщик НПД), ИНН …» — одной строкой, для начала документов и подвала сайта. */
export const OPERATOR_LINE = `${OPERATOR.name} (${OPERATOR.status}), ИНН ${OPERATOR.inn}`;

/** Дата редакции документов — меняется вместе с текстом. */
export const LEGAL_UPDATED = '2026-10-27';

export const SERVICE_NAME = 'Boltaem';
/** Не из env: документы называют прод-домен, а не адрес текущей сборки. */
export const SITE_DOMAIN = 'boltaem.chat';
/** Веб-приложение — тот же Сервис в браузере, со входом через Яндекс ID или VK ID (WEB.md). */
export const APP_DOMAIN = 'app.boltaem.chat';
/**
 * Чем входят в веб-приложение. Это не обработчики по поручению, а источники:
 * Оператор получает от них данные с разрешения пользователя в окне входа.
 */
export const LOGIN_PROVIDERS = 'Яндекс ID (ООО «Яндекс») или VK ID (ООО «ВК»)';
export const BOT_USERNAME = 'boltaem_app_bot';

/** Приём оплаты и чеки. Данные карты к нам не попадают — их вводят на странице ЮKassa. */
export const PAYMENT_PROVIDER = 'ЮKassa (ООО НКО «ЮМани»)';

/**
 * Веб-аналитика сайта и веб-приложения. Её запросы и так видны любому посетителю в браузере —
 * название не раскрывает стек. Счётчик грузится сразу при заходе на сайт:
 * согласие — продолжение пользования сайтом (политика, раздел 7).
 */
export const ANALYTICS = 'Яндекс Метрика (ООО «Яндекс»)';

/**
 * Кому передаём данные — публично только категориями, без названий компаний:
 * стек — коммерческая тайна, конкурент не должен собрать его по нашей политике.
 * Конкретные подрядчики сообщаются субъекту по запросу (п. 9 ч. 7 ст. 14
 * 152-ФЗ); их список — в DEPLOY.md, «Юридическое». Telegram и платёжный
 * провайдер названы: они и так видны пользователю.
 */
export const PROCESSOR_GROUPS = [
  {
    who: 'Telegram',
    what: 'идентификатор, имя и имя пользователя в Telegram, язык интерфейса',
    why: 'вход в Сервис, работа бота и мини-приложения',
  },
  {
    who: 'Почтовый сервис (Россия)',
    what: 'адрес электронной почты и текст уведомления о подписке',
    why: 'отправка уведомлений о подписке тем, у кого не подключён Telegram или кому туда не доставлено сообщение',
  },
  {
    who: 'Поставщики технологий обработки речи и текста, в том числе иностранные',
    what: 'голосовые и текстовые сообщения, имя для обращения, сведения о целях и интересах — без идентификатора Telegram',
    why: 'работа ИИ-репетитора',
  },
] as const;
